<template>
  <div id="container">
    <div class="location">
      <ul>
        <li class="home">홈</li>
        <li>적하보험</li>
        <li>상품안내</li>
        <li>적하보험의 개요</li>
      </ul>
    </div>

    <div class="pageTit">
      <div class="conWrap">
        <h2>적하보험의 개요</h2>
        <div class="depLink">
          <button type="button" title="메뉴">
            <span>적하보험의 개요</span>
          </button>
          <ul>
            <li>
              <router-link to="/insursumCargoidm"
                ><span>적하보험의 개요</span></router-link
              >
            </li>
            <li>
              <router-link to="/cargotarProdguid"
                ><span>적하보험의 가입대상</span></router-link
              >
            </li>
            <li>
              <router-link to="/condcovProdguid"
                ><span>조건별 담보안내</span></router-link
              >
            </li>
            <li>
              <router-link to="/insurstrtProdguid"
                ><span>보험의 개시와 종료</span></router-link
              >
            </li>
            <li>
              <router-link to="/premcalProdguid"
                ><span>보험료 산출 및 납입</span></router-link
              >
            </li>
            <li>
              <router-link to="/blaninsurProdguid"
                ><span>포괄보험 안내</span></router-link
              >
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="contents">
      <div class="conWrap">
        <div class="conStyle2">
          <div class="imgWrap">
            <img src="@/assets/images/imgPdtInfo1.png" alt="" />
          </div>

          <div class="txtWrap">
            <p class="tit">
              적하보험은 <span class="fcRed">운송 중</span><br />
              발생하는 사고로 인한 <br />
              <span class="fcRed">손해를 보상</span>합니다.
            </p>
            <p class="txt">
              적하보험은 선박이나 항공기로 운송되는 화물이 운송도중에 발생한
              사고로<br />
              손해를 입었을 경우 그 손해를 보상하는 보험이며,<br />
              보험계약 성립을 증명하는 서류인 보험증권은 선적서류 즉,<br />
              선하증권, 상업송장 등과 함께 환어음에 첨부되어 무역대금 결제의<br />
              수단으로 이용됨으로써 국제 무역 거래의 중요한 역할을 담당하고
              있습니다.<br />
              적하 보험 계약 청약 시 증권 발급 및 보험료 산정에 필요한<br />
              사항은 아래와 같습니다.
            </p>
            <button type="button" @click="openPopup('PopChkNeed')" class="link">
              <span>필요사항 확인하기</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <PopChkNeed ref="PopChkNeedRef" @close="handlePopupClose"></PopChkNeed>
</template>

<script setup>
// @ is an alias to /src

import { ref, reactive, inject, onMounted, onBeforeUpdate } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import util from "@/common/util";
import { sessionUserInfo, load } from "@/common/sessionFactory";
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";
import PopChkNeed from "@/components/common/layerPop/PopChkNeed.vue";
const swalAlert = inject("swalAlert");
const handlePopupClose = () => {};
const PopChkNeedRef = ref(null);
const openPopup = (name) => {
  if ("PopChkNeed" == name) {
    PopChkNeedRef.value.open();
  }
};
</script>
